import { intialState } from "./JoinNowForm.interface";

type formVals = typeof intialState;
export const fNameValid = (formValue: formVals, setFormValue, t) => {
  setFormValue((old) => {
    return {
      ...old,
      errors: {
        fname: "",
        lname: "",
        email: "",
        password: "",
        confirmPassword: "",
        gender: "",
        dob: "",
        referral: "",
        con1: "",
        con2: "",
      },
    };
  });
  const valid = true;
  const validregex = /^\S+(?:\s*\S+)*$/;
  if (formValue.firstName.length < 1) {
    setFormValue((old) => {
      return { ...old, errors: { ...old.errors, fname: t("form.join.First") } };
    });
    return false;
  } else if (!validregex.test(formValue.firstName)) {
    setFormValue((old) => {
      return { ...old, errors: { ...old.errors, fname: t("changePassword.error.blank") } };
    });
    return false;
  } else if (!/^[a-zA-Z]+$/.test(formValue.firstName.trim())) {
    setFormValue((old) => {
      return { ...old, errors: { ...old.errors, fname: t("change.password.allowed") } };
    });
    return false;
  }
  if (formValue.lastName.length < 1 || !validregex.test(formValue.lastName)) {
    setFormValue((old) => {
      return { ...old, errors: { ...old.errors, lname: t("form.join.required") } };
    });
    return false;
  }
  if (!validregex.test(formValue.lastName)) {
    setFormValue((old) => {
      return { ...old, errors: { ...old.errors, lname: t("changePassword.error.blank") } };
    });
    return false;
  }
  if (!/^[a-zA-Z]+$/.test(formValue.lastName.trim())) {
    setFormValue((old) => {
      return { ...old, errors: { ...old.errors, lname: t("change.password.allowed") } };
    });
    return false;
  }
  return valid;
};

export const PasswordValid = (formValue: formVals, setFormValue, t) => {
  setFormValue((old) => {
    return {
      ...old,
      errors: {
        fname: "",
        lname: "",
        email: "",
        password: "",
        confirmPassword: "",
        gender: "",
        dob: "",
        referral: "",
        con1: "",
        con2: "",
      },
    };
  });
  const validregex = /^\S+(?:\s*\S+)*$/;

  // Trim spaces from password and confirm password
  const trimmedPassword = formValue.password.trim();
  const trimmedConfirmPassword = formValue.confirmPassword.trim();

  // Check if password contains spaces
  if (trimmedPassword.includes(" ")) {
    setFormValue((old) => {
      return {
        ...old,
        errors: { ...old.errors, password: t("change.password.Password")},
      };
    });
    return false;
  }

  // Check if confirm password contains spaces
  if (trimmedConfirmPassword.includes(" ")) {
    setFormValue((old) => {
      return {
        ...old,
        errors: { ...old.errors, confirmPassword: t("change.password.Password")},
      };
    });
    return false;
  }

  // Check if password exceeds 16 characters
  if (trimmedPassword.length > 16) {
    setFormValue((old) => {
      return {
        ...old,
        errors: { ...old.errors, password: t("changePassword.error.max16") },
      };
    });
    return false;
  }

  // Check if confirm password exceeds 16 characters
  if (trimmedConfirmPassword.length > 16) {
    setFormValue((old) => {
      return {
        ...old,
        errors: { ...old.errors, confirmPassword: t("changePassword.error.max16") },
      };
    });
    return false;
  }

  if (trimmedPassword.length === 0) {
    setFormValue((old) => {
      return {
        ...old,
        errors: { ...old.errors, password: t("change.password.Firstly") },
      };
    });
    return false;
  } else if (trimmedPassword.length < 6) {
    setFormValue((old) => {
      return {
        ...old,
        errors: { ...old.errors, password: t("changePassword.error.min6") },
      };
    });
    return false;
  } else if (!validregex.test(trimmedPassword)) {
    setFormValue((old) => {
      return {
        ...old,
        errors: { ...old.errors, password: t("changePassword.error.blank") },
      };
    });
    return false;
  }

  if (trimmedConfirmPassword.length === 0) {
    setFormValue((old) => {
      return {
        ...old,
        errors: { ...old.errors, confirmPassword: t("change.password.confirm") },
      };
    });
    return false;
  } else if (trimmedConfirmPassword.length < 6) {
    setFormValue((old) => {
      return {
        ...old,
        errors: { ...old.errors, confirmPassword: t("changePassword.error.min6") },
      };
    });
    return false;
  } else if (!validregex.test(trimmedConfirmPassword)) {
    setFormValue((old) => {
      return {
        ...old,
        errors: {
          ...old.errors,
          confirmPassword: t("changePassword.error.blank"),
        },
      };
    });
    return false;
  }

  if (trimmedPassword !== trimmedConfirmPassword) {
    setFormValue((old) => {
      return {
        ...old,
        errors: { ...old.errors, confirmPassword: t("change.password.doesn") },
      };
    });
    return false;
  }

  return true;
};

export const genderValid = (formValue: formVals, setFormValue, ageValidator, t) => {
  setFormValue((old) => {
    return {
      ...old,
      errors: {
        fname: "",
        lname: "",
        email: "",
        password: "",
        confirmPassword: "",
        gender: "",
        dob: "",
        referral: "",
        con1: "",
        con2: "",
      },
    };
  });
  const valid = true;
  const dobRegex = /^\d{4}-(0?[1-9]|1[0-2])-(0?[1-9]|[12][0-9]|3[01])$/;
  if (!formValue.gender) {
    setFormValue((old) => {
      return {
        ...old,
        errors: { ...old.errors, gender: t("form.join.gender") },
      };
    });
    return false;
  }
  if (!(formValue.dateOfBirth && dobRegex.test(formValue.dateOfBirth))) {
    setFormValue((old) => {
      return {
        ...old,
        errors: { ...old.errors, dob: t("form.join.Date") },
      };
    });
    return false;
  } else if (!ageValidator(formValue.dateOfBirth, 18)) {
    setFormValue((old) => {
      return {
        ...old,
        errors: { ...old.errors, dob: t("form.join.underAgeError") },
      };
    });
    return false;
  }
  return valid;
};

export const commanValidation = async (formValue: formVals, setFormValue, con2, t) => {
  // setError("");
  setFormValue((old) => {
    return {
      ...old,
      errors: {
        fname: "",
        lname: "",
        email: "",
        password: "",
        confirmPassword: "",
        gender: "",
        dob: "",
        referral: "",
        con1: "",
        con2: "",
      },
    };
  });
  const valid = true;

  // email validation patterns
  const regexEmail = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/i;
  const validregex = /^\S+(?:\s*\S+)*$/;
  // email validation

  if (!(formValue.email && regexEmail.test(formValue.email.trim()))) {
    setFormValue((old) => {
      return { ...old, errors: { ...old.errors, email: t("form.join.address") } };
    });
    return false;
  } else if (!validregex.test(formValue.email)) {
    setFormValue((old) => {
      return { ...old, errors: { ...old.errors, email: t("changePassword.error.blank") } };
    });
    return false;
  }

  if (!formValue.gender) {
    setFormValue((old) => {
      return {
        ...old,
        errors: { ...old.errors, gender: t("form.join.gender") },
      };
    });
    return false;
  }

  if (!con2) {
    setFormValue((old) => {
      return {
        ...old,
        errors: { ...old.errors, con2: t("form.join.accepts") },
      };
    });
    return false;
  }

  return valid;
};